import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Injector, OnDestroy, OnInit, ViewChild, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { FontSetList, themeList } from '@app/@core/entities/theme-constants';
import { LocalStorageService } from '@app/@core/local-storage/local-storage.service';
import { AuthService } from '@app/@core/services/auth.service';
import { LocalService } from '@app/@core/services/local.service';
import { SharedService } from '@app/@core/services/shared.service';
import { SocketAdapterService } from '@app/@core/services/socket-adapter.server';
import { ThemeService } from '@app/@core/services/theme.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { PageHeaderService } from '@app/shared/modules/page-header/@core/page-header.service';
import { PagesService } from '@app/shared/modules/page-header/@core/pages.service';
import { ProfileService } from '@app/shared/modules/profile/profile.service';
import { CommonService } from '@app/shared/services/common.service';
import { CustomValidator } from '@app/shared/validator/custom-validator';
import { AppConstants } from '@core/entities/app-constants';
import { AlertService } from '@core/services/alert.service';
import { AppService } from '@core/services/app.service';
import { environment } from '@env/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { DynamicTabPageService, PlatformDataStoreService } from '@pics-core/dynamic';
import { ProfileUpdateService } from '@pics-core/profile';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { forkJoin, Subject, Subscription , interval} from 'rxjs';
import { ChatService } from './chat/@core/services/chat.service';
import { MailNotificationService } from './main-notification/@core/main-notification.service';
import { ConfigurationSettingsService } from './pics-config-login-settings/@core/configuration-settings.service';
import { GlobalSearchService, DataStoreService as elasticDataStore } from '@pics-core/elasticsearch';
import { DataStoreService } from '@app/@core/services/data-store.service';
import { HttpService } from '@app/@core/services/http.service';
import { RegistrationService } from '@app/registration/registration.service';
import { filter, take, takeUntil ,  map} from 'rxjs';
import { ModalConfig, modalContent, modalHeading } from '@app/shared/constants/modal.model';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { InAppNotificationService } from '@pics-core/common-utils';
import { HeaderContainerConfig, HeaderPlatformContext } from '@pics-core/page-header';
import { HeaderConfigService } from './header-components/header-config.service';
import { DataStoreService as NotificationDataStoreService } from '@pics-module/notification-alert';
import { PaymentResetService } from '@app/payment/paymentform/payment-reset.service';
import { QueuesService } from '@app/Queues/queues.service';
declare const $: any;
const NOT_AVAILABLE = 'Not Available';
const ROUTE_URL = '/pages/main-notification';
const PAGES_PROFILE = '/pages/profile';
const noInternetSelector = '#noInternet';
const sessionExpiredSelector = '#SessionExpired';
const noInternetWithTimmerSelector = '#noInternetWithTimmer';
const logoutEvent = 'logout-event';

@Component({
  standalone: false,
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit, OnDestroy {
  @ViewChild('notificationAlert', { static: false }) private notificationAlert;
  @ViewChild('popup', { static: false }) popupRef: ElementRef;
  @ViewChild('trigger', { static: false }) triggerRef: ElementRef;
  @ViewChild('sessionModal') sessionModal: ElementRef;
  currentPage?: any;
  username: any;
  showname: any;
  rolename: any;
  profileUpdateService: ProfileUpdateService;
  registrationService: RegistrationService
  resetPasswordForm!: UntypedFormGroup;
  display = false;
  errors = AppConstants.errorList;
  thumbnail!: string;
  isValid = false;
  visibleSidebar2;
  activityLogPageload: Promise<boolean> | undefined;
  active = false;
  completevalue = 80;
  showCount = true;
  notificationCount = 0;
  sidebarMenu: boolean;
  alertService: AlertService;
  appService: AppService;
  storeService: DataStoreService;
  orgOptions: any = [];
  selectedOrg: any;
  disable: boolean;
  orgName: any;
  themes: any = [];
  fontSetList: any = [];
  selectedTheme: any;
  selectedFont: any;
  themeService: ThemeService;
  // localstorage: LocalService;
  showThemeCustomizer: boolean;
  rocketIcon: string;
  pageIcon: string;
  statuses: any = [];
  selectedStatus: any;
  notificationMessage: string;
  socketAdapter: SocketAdapterService;
  socketSubscription: Subscription;
  taskId: number;
  kmsHost: string;
  lmsHost: string;
  pagename: string;
  sidebarMenuClass = true;
  profileservice: ProfileService;
  subMenuName = 'Designers';
  permissionStore: PermissionStore;
  showNavbar: boolean;
  pageHeaderService: PageHeaderService;
  dynamicTabPageService: DynamicTabPageService;
  currentUser: [] = [];
  authService: AuthService;
  commonService: CommonService;
  unreadMessages: any[];
  chatService: ChatService;
  environment: any;
  configSettings: any;
  countdown?: number = null;
  countdownMin?: string = null;
  timeoutValue: any;
  appPageState: any;
  previouslySelectedMenu: string;
  currentState!: ConnectionState;
  isOnline: boolean = true;
  sessionExpiredPopUp = false;
  sessionExpiredBoolean = false;
  inActivity: number;
  dataSource: any;
  http: HttpClient;
  pagesservice: PagesService;
  sharedService: SharedService;
  connectionService: ConnectionService;
  StorageService: LocalStorageService;
  configurationSettingsService: ConfigurationSettingsService;
  private _mailNotificationService: InAppNotificationService;
  private notificationSubscription: Subscription;
  flashInterval$: Subscription | null = null;
  applicationHidden = false;
  currentTitle: string;
  private notificationCountSub: Subscription | null = null;
  headerConfig: HeaderContainerConfig;
  headerContext: HeaderPlatformContext | null = null;
  titleService: Title;
  isMenuOpen: boolean = false;
  paymentResetService: PaymentResetService;
  subscription: Subscription;
  searchQuery: string = '';
  isPopupVisible: boolean = false;
  globalSearchService: GlobalSearchService;
  // searchResult : any;
  searchResult: any = { data: [] }; 
  groupedResults: any = {}; 
  expandedIndexes: any = {}; 
  activeTab: string = 'all';
  httpService: HttpService;
  elasticDataStore: elasticDataStore;
  platformDataStoreService: PlatformDataStoreService;
  renderer: Renderer2;
  private globalClickUnlistener: () => void;
  enableGlobalSearch: boolean;
  navigationSubscription: Subscription;
  errorMessages: any
  toastMessage: any
  toastMessages: any
  errorMessage: any

  sessionTimeout: number = 300;
  private destroy$ = new Subject<void>();
  modalConfig!: ModalConfig;
  showModal = false; 
  queuesService: QueuesService;

  constructor(
    injector: Injector,
    private _router: Router,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private breakpointObserver: BreakpointObserver,
    private idle: Idle,
    private cd: ChangeDetectorRef,
    private localstorage: LocalService,
    @Inject(DOCUMENT) private document: Document,
    private readonly notificationDataStoreService :NotificationDataStoreService,
    private readonly headerConfigService: HeaderConfigService,

  ) {
    this.renderer = injector.get(Renderer2);
    this.profileUpdateService = injector.get<ProfileUpdateService>(ProfileUpdateService);
    this.registrationService = injector.get<RegistrationService>(RegistrationService);
    this.authService = injector.get<AuthService>(AuthService);
    this.alertService = injector.get<AlertService>(AlertService);
    this.appService = injector.get<AppService>(AppService);
    // this.localstorage = injector.get<LocalService>(LocalService);
    this.themeService = injector.get<ThemeService>(ThemeService);
    this.socketAdapter = injector.get<SocketAdapterService>(SocketAdapterService);
    this.profileservice = injector.get<ProfileService>(ProfileService);
    this.permissionStore = injector.get<PermissionStore>(PermissionStore);
    this.pageHeaderService = injector.get<PageHeaderService>(PageHeaderService);
    this.dynamicTabPageService = injector.get<DynamicTabPageService>(DynamicTabPageService);
    this.chatService = injector.get<ChatService>(ChatService);
    this.commonService = injector.get<CommonService>(CommonService);
    this.pagesservice = injector.get<PagesService>(PagesService);
    this.sharedService = injector.get<SharedService>(SharedService);
    this.connectionService = injector.get<ConnectionService>(ConnectionService);
    this.StorageService = injector.get<LocalStorageService>(LocalStorageService);
    this.configurationSettingsService = injector.get<ConfigurationSettingsService>(ConfigurationSettingsService);
    this._mailNotificationService = injector.get<InAppNotificationService>(InAppNotificationService);
    this.headerConfig = this.headerConfigService.createInitialConfig();
    this.StorageService = injector.get<LocalStorageService>(LocalStorageService);
    this.titleService = injector.get<Title>(Title);
    this.globalSearchService = injector.get<GlobalSearchService>(GlobalSearchService);
    this.storeService = injector.get<DataStoreService>(DataStoreService);
    this.platformDataStoreService = injector.get<PlatformDataStoreService>(PlatformDataStoreService);
    this.httpService = injector.get<HttpService>(HttpService);
    this.http = injector.get<HttpClient>(HttpClient);
    this.platformDataStoreService.setData('HTTPSERVICE', this.httpService);
    this.elasticDataStore = injector.get<elasticDataStore>(elasticDataStore);
    this.paymentResetService = injector.get<PaymentResetService>(PaymentResetService);
    this.queuesService = injector.get<QueuesService>(QueuesService);
    this.showNavbar = this.permissionStore.state.APP_SIDE_NAVBAR;
    this.display = false;
    this.showThemeCustomizer = false;
    this.username = this.localstorage.getItem('username') || '';
    this.kmsHost = environment.KMS_URL;
    this.lmsHost = environment.LMS_URL;
    this.enableGlobalSearch = true;
    const page = location.pathname.split('/')[2];
    this.currentPage = AppConstants.PAGES.find(p => p.page === page);
    this.themes = themeList;
    this.fontSetList = FontSetList;
    this.selectedTheme = this.localstorage.getItem('SELECTED_THEME') || 'default';
    this.selectedFont = this.localstorage.getItem('SELECTED_FONT') || 'medium';
    this.rocketIcon = this.themes.filter(a => a.key === this.selectedTheme)[0]?.properties['--rocket-icon'];
    this.pagename = JSON.parse(this.localstorage.getItem('currentpage'));
    this.appService.currentState.subscribe(data => {
      if(data.value == 'Message Center'){
        const menus = this.localstorage.getObj('MENU');
        const findMenu = menus.find(item => item.name === 'Message Center');
        menus.forEach(item => {
          item.active = item === findMenu;
        });

        data.value = findMenu;
      }
      this.pageIcon = data?.value?.additionalinfo?.icon;
      this.pagename = data?.value?.name || data.value;
      if (data.key === 'currentPage' && data.value !== 'help-desk') {
        this.currentPage = AppConstants.PAGES.find(p => p.page === data.value);
      }
      if (data.key === 'dynamicPages') {
        this.currentPage = AppConstants.PAGES.find(p => p.page === 'dynamicPages');
        this.currentPage.title = data.value.pagename ? data.value.pagename : '';
      }
      this._router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.activePageDetails(data);
        }
      });
      this.activePageDetails(data);
    });
    this.conditionCheckShowCount();

    this.breakpointObserver.observe(['(max-width: 960px)']).subscribe((result: BreakpointState) => {
      if (result.matches) {
        this.sidebarMenu = false;
      } else {
        this.sidebarMenu = true;
      }
    });
    this._mailNotificationService.notificationCount.subscribe(n => (this.notificationCount = n));
    this.statuses = [
      { name: 'Available', code: 'Available' },
      { name: NOT_AVAILABLE, code: NOT_AVAILABLE }
    ];
    this.appService.getValue.subscribe(val => {
      this.subMenuName = (val.key === 'SubMenu' && val.value) || '';
    });
    this.authService.currentMenu.subscribe(x => {
      if (x.length > 0) {
        this.currentUser = x;
      }
    });
    this.timeoutValue = this.localstorage.getItem('timeout');
  this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
  this.idle.onIdleStart.pipe(takeUntil(this.destroy$)).subscribe(() => {
      /*OnIdle*/
      
      if (this.isOnFeePaymentPage()) {
        this.paymentResetService.triggerFormReset();
      }
      if (this.isOnline) {
        $(this.sessionModal.nativeElement).modal({
          backdrop: 'static',
          keyboard: false
        }).modal('show');
        this.idle.setInterrupts([]);
      } else {
        $(noInternetWithTimmerSelector).modal({ backdrop: 'static', keyboard: false }, 'show');
      }
      this.sessionExpiredPopUp = true;
    });

    this.idle.onIdleEnd.subscribe(() => {
      /*No Longer Idle*/
      this.countdown = null;
      this.cd.detectChanges();
    });
    // this.idle.onInterrupt.subscribe(() => {
    //   console.log('User activity detected.');
    // });

    this.idle.onTimeout.subscribe(() => {
      /*Timed Out*/
      this.onLoggedout();
    });
    this.idle.onTimeoutWarning.subscribe(seconds => this.updateCountdown(seconds));
    this.pagesservice.currentValue.subscribe(data => {
      this.sidebarMenu = data;
    });
    this.checkInternetConnected();
    this.storageEventStart();
    this.sharedService.currentMessage.subscribe((_message: any) => {
      this.getNotificationList();
    });

  }
  updateCountdown(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    this.countdownMin = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    this.cd.detectChanges();
  }
  conditionCheckShowCount() {
    if (this._router.url === ROUTE_URL) {
      this.showCount = true;
    }
  }
  
ngOnInit(): void {
  // Subscribe to NavigationEnd to run logic whenever route becomes active
  // this.navigationSubscription = this._router.events.pipe(
  //   filter(event => event instanceof NavigationEnd)
  // ).subscribe(() => {
  //   this.runLegacyUserLogic();
  // });

  // Initial call for page reload
    this.navigationSubscription = this._router.events.pipe(
    filter(event => event instanceof NavigationEnd)
  ).subscribe(() => {
    this.handleApplicationUnlock();
  });
  this.runLegacyUserLogic();
  this.handleApplicationUnlock();

  // Existing initialization logic
  this.loadDropdownData();
  this.socketAdapter.connect();
  this.socketAdapter.getUnreadMessages().subscribe(messages => {
    this.unreadMessages = [...messages];
  });

  this.profileservice.setUserPreference();
  this.getAuthMe();
  this.getConfigSettings();
  this.initializeResetPasswordForm();
  this.getNotificationList();
  this.getUserOrgList();
  this.environmentSetup();
  this.getWorkerAvailability();
  this.setTheme(this.selectedTheme);
  this.setFont(this.selectedFont);

  this.profileUpdateService.profilePicture$
    .pipe(take(1), takeUntil(this.destroy$))
    .subscribe(_path => {
      this.getAuthMe();
  });
  this.profileservice.profileImage.subscribe((img: any) => {
    this.thumbnail = img.url ? img.url : 'assets/images/neveda-images/Profile.svg';
    this.showname = img.name;
    this.updatePlatformHeaderConfig();
  });
  if (this._router.url === PAGES_PROFILE) {
    this.routerNavigator('pages/profile');
  }
  const mobileMediaQuery = window.matchMedia('(max-width: 960px)');
  if (mobileMediaQuery.matches) {
    this.sidebarMenu = false;
  }

  this.subscription = this.appService.toggleStatus$.subscribe((status: boolean) => {
    this.isMenuOpen = status;
  });

  window.onresize = () => {
    this.checkScaleAndRemoveClass();
  };

  this.settingDataSourceInElasticSearch();
   this.currentTitle = this.document.title;

 this.socketAdapter.connect();
 this.socketAdapter.register(sessionStorage.getItem('id'));

 this.notificationSubscription =
   this.socketAdapter.receiveNotification().subscribe(notification => {

     const sanitized = notification.replace(/[<>]/g, '');

     this.alertService.warn(`🔔 New Notification<br/>${sanitized}`);

     this.notificationDataStoreService.currentStoreSubject.next({
       notificationTrigger: 'notificationTrigger'
     });

     this.getNotificationCount();

     if (this.applicationHidden && !this.flashInterval$) {
       this.flashNotificationTitle();
     }
 });

 this.getNotificationCount();
 this.buildHeaderContext();
this.updatePlatformHeaderConfig();

this.socketAdapter.onForceLogout().subscribe(() => {
  console.log('[PagesComponent] Force logout received via socket');
  this.onLoggedout();
});
}


// Extracted legacy user logic into a reusable method
private runLegacyUserLogic(): void {
  if (this.commonService.getLegacyFlag()) {
    const currentUrl = this._router.url;
    if (!currentUrl.includes('manage-profile')) {
      const modalRef = this.modalService.open(ModalComponent, {
        backdrop: 'static',
        keyboard: false,
        centered: true
      });

      modalRef.componentInstance.modalConfig = {
        heading: modalHeading.legacyUser,
        modalContent: modalContent.legacyUserFirstLogin,
        hasTemplate: true,
        buttons: [
          { text: 'Go to My Profile', code: 'Y', btnOutline: false }
        ],
        align: false,
        hideCloseIcon: false
      };

      modalRef.componentInstance.emitData.subscribe((result: any) => {
        if (result?.confirmed) {
          this.goToProfile();
        }
      });
    }
  }
}

goToProfile(): void {
  this._router.navigate(['/pages/manage-profile']);
}

  private async loadDropdownData() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get(`/registration/getNames?email=${this.email}`),
      this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES')
    ]).subscribe({
      next: (item: any) => {
        console.log(item);
        this.errorMessages = item[0].data;
        this.toastMessages = item[1].data;
        this.namesObj=item[2].data.data;

        this.errorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('errorMessage', JSON.stringify(this.errorMessage));
        this.toastMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('toastMessage', JSON.stringify(this.toastMessage));

        this.placeholderMessages = item[3].data;
        this.placeholderMessages.forEach(message => {
            if (message.key && message.value !== undefined) {
              this.placeholderMessage[message.key] = message.value;
            }
          });
        window.localStorage.setItem('placeholderMessage', JSON.stringify(this.placeholderMessage));

      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });


  }

  ngOnDestroy(): void {
    if (this.socketSubscription) {
      console.log('Unsubscribing...');
      this.socketSubscription.unsubscribe();
    }
    this.socketAdapter.disconnect();
    this.localstorage.removeItem('SELECTED_THEME');
    this.appService.setValue('SubMenu', '');
    this.storageEventStop();
    this.subscription.unsubscribe();
    
  if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    window.removeEventListener('resize', this.checkScaleAndRemoveClass.bind(this));

    if (this.globalClickUnlistener) {
      this.globalClickUnlistener();
      this.globalClickUnlistener = null;
    }
    
  this.destroy$.next();
  this.destroy$.complete();
 this.notificationSubscription?.unsubscribe();
 this.notificationCountSub?.unsubscribe();
 this.flashInterval$?.unsubscribe();

  }

  checkScaleAndRemoveClass() {
    const scale = window.devicePixelRatio * 100;
    const element = document.querySelector('.pageWrapper.active');

    if (Math.abs(scale - 175) < 1) {
      if (element?.classList.contains('hmenu')) {
        element.classList.remove('hmenu');
      }
    }
  }

  pollUnNotified() {
    setInterval(() => {
      this.authService.getUnNotified().subscribe(({ data: _notification }: any) => {
        const userId = this.localstorage.getItem('id');
        if (Number(userId) === Number(_notification?.user_id) && !this.modalService.hasOpenModals()) {
          this.taskId = _notification.id;
          this.notificationMessage = _notification?.task_name;
          this.modalService.open(this.notificationAlert);
        }
      });
    }, 5000);
  }

  updateNotification() {
    this.authService.updateUnNotified({ id: this.taskId }).subscribe(_data => {
      console.log(_data);
      this.modalService.dismissAll();
    });
  }

  getWorkerAvailability() {
    this.authService.getWorkerAvailability().subscribe((res: any) => {
      if (res && res.data) {
        const status = res.data.worker_availablity;
        const currentStatus = this.localstorage.getItem('availability');
        if (status === 'Available' && currentStatus !== 'Available') {
          this.updateStatus(NOT_AVAILABLE);
        }
        this.selectedStatus = status;
      }
    });
  }

  updateStatus(e) {
    const reqBody = {
      workerAvailablity: e
    };
    this.localstorage.setItem('availability', e);
    this.authService.updateWorkerAvailability(reqBody).subscribe(() => {
      this.selectedStatus = e;
    });
  }

  connectSocket() {
    const user_id = this.localstorage.getItem('id');
    console.log('Connecting to socket...');
    this.socketSubscription = this.socketAdapter.receivedNotification().subscribe(data => {
      console.log('Notification received...', data);
      console.log('Notification received...', Number(user_id) === Number(data?.userId));
      if (Number(user_id) === Number(data?.userId)) {
        console.log('Notification Recieved');
        this.notificationMessage = data?.taskName;
        this.modalService.open(this.notificationAlert);
      }
    });
  }

  organisationSelect(eve: any) {
    this.authService.feedOrgInfo(eve.node.id);
    this.localstorage.setItem('orgid', eve.node.id);
  }

  getUserOrgList() {
    this.authService.getUserOrgList().subscribe(
      (res: any) => {
        console.log(res);
        this.orgOptions = res.data;
        this.selectedOrg = res.data[0];
        this.authService.feedOrgInfo(res.data[0].id);
        this.localstorage.setItem('orgid', res.data[0].id);
        if (this.orgOptions[0].children.length) {
          this.disable = false;
        } else {
          this.orgName = this.orgOptions[0].name;
          this.disable = true;
        }
      },
      error => {
        console.log(error);
      }
    );
  }
  environmentSetup() {
    this.authService.getAuthMe().subscribe((res: any) => {
      if (res.data) {
        this.environment = res.data?.environment;
      }
    });
  }

  refreshToken() {
    /*No Longer Idle*/
    $(sessionExpiredSelector).modal('hide');
    this.countdown = null;
    this.idle.stop();
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.sessionExpiredPopUp = false;
    this.idle.setIdle(this.inActivity);
    this.idle.setTimeout(this.sessionTimeout);
    this.idle.watch();
  }

  resetIdleTimer() {
    this.refreshToken();
    window.localStorage.setItem('refresh-token', Math.random().toString());
  }

  async getAuthMe() {
    this.authService.getAuthMe().subscribe(
      async (res: any) => {
        if (res.data) {
          const userid = res.data.id;
          //Idle Timeout is only working in seconds, Input in Minutes from API, Multiplied with 60 for Seconds
          // const inactivity: number = (res?.data?.timeout || 30) * 60;
          const timeoutMinutes = await this.fetchInactivityTimeoutFromLookup();
          const inactivity = timeoutMinutes * 60;
          sessionStorage.setItem('timeout', inactivity + '');
          this.localstorage.setItem('timeout', inactivity + '');
          this.inActivity = inactivity;
          this.idle.setIdle(this.inActivity);
          this.idle.setTimeout(this.sessionTimeout);
          this.idle.watch();
          //storing api url for formio api requests
          this.localstorage.setItem('apiHost',environment.apiHost);
          sessionStorage.setItem('apiHost',environment.apiHost);
          if (res.data?.supportApiCredentials) {
            this.storeService.setData('support-api-creds', res.data.supportApiCredentials);
          }
          this.authService.getUserRole(userid).subscribe(response => {
            if (response) {
              this.showname = response.data.firstname + ' ' + response.data.lastname;
              this.thumbnail = response.data?.additionalinfo?.thumbnail?.url || 'assets/images/neveda-images/Profile.svg';
              this.rolename = response.data.userroles[0].name;
               this.localstorage.setItem('role_id', response.data?.userroles[0]?.id);
               this.localstorage.setItem('user', JSON.stringify(response.data));
              //sessionStorage.setItem('role_id', response.data?.userroles[0]?.id);
              //sessionStorage.setItem('user', JSON.stringify(response.data));
              this.commonService.setUserData(response.data);
              this.commonService.setApplicationState({ role_id: response.data?.userroles[0]?.id });
            }
          });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onLoggedout() {
    this.logoutLogHistory();
    if (!this.isOnline) {
      window.localStorage.setItem(logoutEvent, Math.random().toString());
      this.localstorage.clear();
      this.navigationTO('no-internet');
      return;
    }
    const currentStatus = this.localstorage.getItem('availability');
    if (currentStatus === 'Available') {
      this.updateStatus(NOT_AVAILABLE);
    }

    this.authService.resetLoggedIn().subscribe((res: any) => {
      if (res.data) {
        window.localStorage.setItem(logoutEvent, Math.random().toString());
        window.location.href = res.data.logoutURL;
        console.log(res.data.logoutURL);
        this.localstorage.clear();
      } else {
        console.log('Unable to create logout URL');
      }
    });
  }


   logoutLogHistory() {
    const user = this.localstorage.getObj('user');
    const userId = user?.id || user?.user_id || user?.userId;
    
    if (!userId) {
      return;
    }

    const applicationId = this.localstorage.getItem('applicationID') || '';

    const payload = {
      user_id: userId,
      application_id: applicationId
    };
    

    this.httpService.patch(API_ENDPOINTS.LOGOUT_HISTORY, payload).subscribe({
      next: (response: any) => {
        console.log('Logout history recorded successfully', response);
      },
      error: (error: any) => {
        console.error('Failed to record logout history', error);
      }
    });
  }

  private handleApplicationUnlock() {
    
    const fullUrl = window.location.href; 
    const isDynamicRoutingPage = fullUrl.includes('/pages/dynamic-routing/tab/');
    
    if (isDynamicRoutingPage) {
      this.localstorage.setItem('previousURL', fullUrl);
    } else {
      const previousURL = this.localstorage.getItem('previousURL');
      
      if (previousURL && previousURL.includes('/pages/dynamic-routing/tab/')) {
        
        const applicationId = this.localstorage.getItem('applicationID');
        
        const user = this.localstorage.getObj('user');
        const userId = user?.id || user?.user_id || user?.userId;
    
        if (!userId) {
          console.warn('[UNLOCK] No current user ID found');
          return;
        }
    
        console.log('[UNLOCK] Navigation detected - fetching lock status from database:', {
          applicationId,
          currentUserId: userId,
          previousURL,
          currentURL: window.location.href
        });
    
        if (applicationId) {
          // Fetch current lock status from database
          const lockStatusPayload = { application_id: applicationId };
          
          this.httpService.post(API_ENDPOINTS.GET_LOCK_STATUS, lockStatusPayload).subscribe({
            next: (lockResponse: any) => {
              // Handle nested response structure: response.data.data.is_lockedby
              const lockData = lockResponse?.data?.data || lockResponse?.data || lockResponse;
              const lockedByUserId = lockData?.is_lockedby || null;
              const lockStatus = lockData?.lockstatus || null;
              
              console.log('[UNLOCK] Lock status fetched from DB:', {
                is_lockedby: lockedByUserId,
                lockstatus: lockStatus,
                currentUserId: userId,
                rawResponse: lockData
              });
              
              // Only unlock if the current user is the one who locked it
              if (!lockedByUserId || Number(lockedByUserId) !== Number(userId)) {
                console.warn('[UNLOCK] Cannot unlock - application not locked by current user', {
                  is_lockedby: lockedByUserId,
                  currentUserId: userId
                });
                // Clean up session storage without calling unlock API
                this.localstorage.removeItem('applicationID');
                return;
              }
              
              // Proceed with unlock since current user is the one who locked it
              const unlockPayload = {
                user_id: userId,
                application_id: applicationId
              };
              
              this.httpService.patch(API_ENDPOINTS.UNLOCK_APPLICATION, unlockPayload).subscribe({
                next: (response: any) => {
                  console.log('[UNLOCK] Application unlocked successfully', response);
                  // Clean up session storage after successful unlock
                  this.localstorage.removeItem('applicationID');
                  // Notify queues component to refresh data
                  this.queuesService.notifyRefreshQueues();
                },
                error: (error: any) => {
                  console.error('[UNLOCK] Failed to unlock application', error);
                  // Clean up session storage even on error
                  this.localstorage.removeItem('applicationID');
                }
              });
            },
            error: (error: any) => {
              console.error('[UNLOCK] Failed to fetch lock status', error);
              // Clean up session storage on error
              this.localstorage.removeItem('applicationID');
            }
          });
        }
      } 
    }
    this.localstorage.setItem('previousURL', fullUrl);
  }

  gotoEmailTemp() {
    this.navigationTO('pages/email-template');
  }

  routeToChat() {
    this._router.navigate(['/pages/chat']);
  }

  getUnreadMessages() {
    this.chatService.getUnreadMessages().subscribe(
      (res: any) => {
        this.unreadMessages = res['data'];
      },
      _error => {
        this.alertService.error(AppConstants.errorMessage);
      }
    );
  }

  gotoVideoConfig() {
    const url = this._router.serializeUrl(this._router.createUrlTree([`/video-conferencing/${this.generateGuid()}`]));
    window.open(url, '_blank');
  }
  generateGuid(): string {
    return (
      'card-inal-' +
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.floor((AppConstants.generateNumber() * 16) / AppConstants.generateNumber());
        const v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      })
    );
  }

  showDialog(changepassword) {
    this.display = true;
    this.modalService
      .open(changepassword, { size: 'md', backdrop: 'static', windowClass: 'changepassword' })
      .result.then();
    this.initializeResetPasswordForm();
  }

  get resetFormcontrols() {
    const newpassword = this.resetPasswordForm.get('newpassword')?.value;
    const conformpassword = this.resetPasswordForm.get('conformpassword');
    if (conformpassword?.value) {
      if (newpassword !== conformpassword.value) {
        conformpassword.setErrors({ ...conformpassword.errors, NoPassswordMatch: true });
      } else {
        if (conformpassword.hasError('NoPassswordMatch')) {
          const errors = { ...conformpassword.errors };
          delete errors.NoPassswordMatch;
          conformpassword.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }
    return this.resetPasswordForm.controls;
  }

  initializeResetPasswordForm() {
    this.resetPasswordForm = this.formBuilder.group({
      id: this.localstorage.getItem('id'),
      mailid: this.localstorage.getItem('email'),
      currentpassword: ['', Validators.required],
      newpassword: [
        '',
        Validators.compose([
          Validators.required,
          CustomValidator.patternValidator(/\d/, { hasNumber: true }),
          CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
          CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
          CustomValidator.patternValidator(/[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/, { hasSpecialCharacters: true }),
          Validators.minLength(8),
          Validators.maxLength(16)
        ])
      ],
      conformpassword: [{ value: '', disabled: true }, Validators.required]
    });
  }
  // TODO - need to work on change password in a separate module later
  changePassword() {
    if (!this.isSameAsOldPassword()) {
      return;
    }
    const obj = {
      username: this.resetPasswordForm.value['mailid'],
      currentPassword: this.resetPasswordForm.value['currentpassword'],
      newPassword: this.resetPasswordForm.value['newpassword']
    };
    this.registrationService.changePassword(obj).subscribe(
      _res => {
        this.onLoggedout();
        this.alertService.success('Password Changed Successfully');
        this.display = false;
        this.modalService.dismissAll('changepassword');
      },
      _error => this.alertService.error('Incorrect Password..')
    );
  }

  private isSameAsOldPassword() {
    const { newpassword, currentpassword } = this.resetPasswordForm.value;
    if (newpassword === currentpassword) {
      this.alertService.error('New Password should not be the same as Old Password.');
      return false;
    }
    return true;
  }

  

  passwordHasMinLength(): boolean {
    const password = this.resetPasswordForm.get('newpassword')?.value;
    return password && password.length >= 8 && password.length <= 16;
  }

  passwordContainsSpaces(): boolean {
    const password = this.resetPasswordForm.get('newpassword')?.value;
    return password && password.includes(' ');
  }

  goToHelpDesk() {
    const url = this._router.serializeUrl(this._router.createUrlTree(['/pages/help-desk']));
    this.appService.addValue('currentPage', 'help-desk');
    window.open(url, '_blank');
  }
  openActivity() {
    this.active = !this.active;
    this.visibleSidebar2 = true;
    this.activityLogPageload = Promise.resolve(true);
  }
  gotoNotification() {
    this.navigationTO('pages/main-notification');
    const obj: any = { name: 'Notifications' };
    this.appService.addValue('currentPage', obj);
    this.showCount = true;
  }
  navigationTO(url) {
    this._router.navigateByUrl(url).then(() => {
      this._router.navigated = false;
      this._router.navigate([url], { replaceUrl: true });
    });
  }
  getNotificationList() {
    this._mailNotificationService.getInitApplicationNotification().subscribe((res: any) => {
      if (res) {
        const notificationCount = res.data;
        this.notificationCount = notificationCount.length > 0 ? notificationCount.length : 0;
        const count = res.data.filter(n => n.isnew);
        const totalCount = count.length ? count.length : 0;
        this._mailNotificationService.getNotificationCount(totalCount);
      }
    });
  }

  sidebar(event: Event) {
    if (event.type === 'click') {
      this.windowResize();
      this.sidebarMenu = true;
      this.sidebarMenuClass = !this.sidebarMenuClass;
    } else if (event.type === 'touchstart') {
      this.sidebarMenuClass = false;
    }
  }

  windowResize() {
    window.addEventListener('resize', _e => {
      const windowWidth = window.innerWidth;
      if (windowWidth > 961) {
        console.log('from 768px');
      } else {
        console.log('less 768px');
      }
    });
  }

  setTheme(event) {
    this.localstorage.setItem('SELECTED_THEME', event);
    const selectedTheme = themeList.filter(theme => theme.key === event)[0];
    this.themeService.setActiveTheme(selectedTheme);
    this.rocketIcon = this.themes.filter(a => a.key === this.selectedTheme)[0].properties['--rocket-icon'];
  }
  setFont(event) {
    this.localstorage.setItem('SELECTED_FONT', event);
    const selectedFont = FontSetList.filter(FontSet => FontSet.key === event)[0];
    this.themeService.setActiveFont(selectedFont);
  }

  settingclick() {
    this.showThemeCustomizer = !this.showThemeCustomizer;
  }

  applyAssistanceModal(assistanceOpen) {
    this.modalService
      .open(assistanceOpen, { size: 'lg', backdrop: 'static', windowClass: 'assistanceopen' })
      .result.then();
  }
  navtoMyApplication() {
    this.navigationTO('pages/application/basic-details');
    this.modalService.dismissAll();
  }
  getCurrentMenu(): any {
    let xyz;
    if (this._router.url == PAGES_PROFILE) {
      xyz = 'Profile';
      return xyz;
    } else if (this._router.url == ROUTE_URL) {
      xyz = 'Notifications';
      return xyz;
    } else {
      if (this.currentUser.length > 0) {
        xyz = this.currentUser.filter(x => x['active']) ? this.currentUser.filter(x => x['active'])[0]?.['name'] : '';
      }
      return xyz ? xyz : '';
    }
  }
  gotoParentPage() {
    const CURRENTMENU = this.localstorage.getObj('CURRENTMENU');
    const CURRENTSUBMENU = this.localstorage.getObj('CURRENTSUBMENU');
    if (CURRENTMENU) {
      if (CURRENTMENU.route?.includes('https') || CURRENTMENU.route?.includes('http')) {
        window.open(CURRENTMENU.route, '_blank');
      } else if (CURRENTMENU.route?.includes('dynamic-search/search')) {
        this.routerDynamicNavigate(CURRENTMENU.submenu[0].activeVersion, CURRENTMENU);
      } else if (CURRENTSUBMENU) {
        if (CURRENTMENU.submenu.length > 0) {
          this._router.navigate([`pages${CURRENTMENU.submenu[0].route}`]);
        }
      } else {
        this._router.navigate([`pages${CURRENTMENU.route}`]);
      }
      this.getMenuActive();
    } else {
      const url = this.currentUser.filter(x => x['active'])
        ? this.currentUser.filter(x => x['active'])[0]['route']
        : '';
      this._router.navigate([`pages${url}`]);
    }
  }
  getSubmenuPage(): any {
    const CURRENTMENU = this.localstorage.getObj('CURRENTMENU');
    const CURRENTSUBMENU = this.localstorage.getObj('CURRENTSUBMENU');
    let xyz;
    if (CURRENTSUBMENU) {
      xyz = this.currentUser.filter((x: any) => x.name === CURRENTMENU.name)[0];
    } else {
      xyz = '';
    }
    return xyz ? xyz['submenu'].filter(x => x.active)[0]?.['name'] : '';
  }
  routerDynamicNavigate(page: any, pageInfo: any) {
    let routingPage = [];
    if (page.tabconfig) {
      const routingTab = typeof page.tabconfig === 'string' ? JSON.parse(page.tabconfig) : page.tabconfig;
      routingPage = routingTab.filter(x => x.type === 'ROUTING');
    }
    if (routingPage.length > 0) {
      this._router.navigate([`${routingPage[0].pathname}`]);
    } else if (page.templatejson && page.tableschemaconfig) {
      this._router.navigate([`pages/dynamicpage/page/modify/${page.pageid}`]);
    } else {
      this._router.navigate([`pages/dynamic-search/search/${page.id}`]);
    }
    this.appService.addValue('dynamicPages', pageInfo);
    this.titleService.setTitle('EMPOWER - ' + page.pagename);
  }
  getMenuActive() {
    const CURRENTMENU = this.localstorage.getObj('CURRENTMENU');
    this.currentUser.map((x: any) => {
      if (x.name === CURRENTMENU.name) {
        x.active = true;
        return x.submenu.map((y, i = 0) => {
          if (i === 0) {
            y.active = true;
          } else {
            y.active = false;
          }
        });
      } else {
        x.active = false;
        return x.submenu.map(y => {
          y.active = false;
        });
      }
    });
    this.authService.getCurrentMenu(this.currentUser);
  }
  getConfigSettings() {
    this.configurationSettingsService.registrationInfo().subscribe(
      (res: any) => {
        if (res.data && res.data.length > 0) {
          const configSettingsList = res.data;
          const valuesMax1 = configSettingsList.map(item => item.id);
          const max1 = Math.max(...valuesMax1);
          this.configSettings = configSettingsList.filter(x => x.id === max1)[0];
        }
        this.StorageService.setItem('REGISTRATION', this.configSettings);
      },
      _err => {
        console.log(_err);
      }
    );
  }

  onclicksettings() {
    this.appService.addValue('currentPage', 'Profile');
  }

  onclickEditProfile() {
    this.appService.addValue('currentPage', 'Profile');
  }

  routerNavigator(route: any) {
    if (route) {
      this.appService.addValue('currentPage', 'Profile');
      this.pagename = 'Profile';
    } else {
      this.pagename = '';
    }
  }
  isString(value: any): boolean {
    return typeof value === 'string';
  }
  activePageDetails(pageObjects) {
    try {
      const currentUrlPath = this.getCurrentUrlPath();

      console.log('currentUrlPath', currentUrlPath);
      console.log('pageObjects', pageObjects);
      const getCurrentPage = pageObjects?.value;

      if (pageObjects?.key === 'dynamicPages') {
        this.handleDynamicPages(getCurrentPage, currentUrlPath);
      } else if (pageObjects?.key === 'currentPage') {
        this.handleCurrentPage(getCurrentPage, currentUrlPath);
      } else {
        this.pagename = this.localstorage.getItem('pagename');
      }

      this.setPagename();
      this.updatePlatformHeaderConfig();
    } catch (e) {
      console.log(`Error in activePageDetails: ${e}`);
    }

    this.checkAndRestorePagename();
    console.log(this.pagename);
  }

  private getCurrentUrlPath() {
    return window.location.pathname.split('/').pop();
  }

  private handleDynamicPages(getCurrentPage, currentUrlPath) {
    const pageDetails = getCurrentPage?.route === `/${currentUrlPath}` ? getCurrentPage : undefined;
    if (pageDetails) {
      this.pagename = getCurrentPage?.name || getCurrentPage;
    } else if (getCurrentPage?.submenu?.length) {
      const activeSubmenuPage = getCurrentPage.submenu.find(item => item?.active);
      this.pagename = activeSubmenuPage?.name || getCurrentPage?.name || getCurrentPage;
    } else {
      this.pagename = getCurrentPage?.name || getCurrentPage;
    }
  }

  private handleCurrentPage(getCurrentPage, currentUrlPath) {
    if (this._router.url === PAGES_PROFILE) {
      this.pagename = 'Profile';
      return;
    }
    else if(this._router.url.includes('pages/dynamic-wizard/tab'))
    {
      this.pagename = 'Application';
      return;
    }
    else if (this._router.url.includes('pages/in-app-message')) {
      this.pagename = 'In-App Messaging';
      return;
    }
    else if (this._router.url.includes('pages/lookup-user')) {
      this.pagename = 'Educator Profile';
      return;
    }
    else if (this._router.url.includes('pages/lea-reports')) {
      this.pagename = 'LEA Reports';
      return;
    }
    else if (this._router.url.includes('pages/epp-reports')) {
      this.pagename = 'EPP Reports';
      return;
    }
    else if (this._router.url.includes('pages/admin-reports')) {
      this.pagename = 'Admin Reports';
      return;
    }
    
    
const queueMappings: { path: string; title: string }[] = [
  { path: 'pages/queues/admin', title: 'Admin Queue' },
  { path: 'pages/queues/intake', title: 'Intake Queue' },
  { path: 'pages/queues/deficiency', title: 'Deficiency Queue' },
  { path: 'pages/queues/analyst', title: 'Analyst Queue' },
  { path: 'pages/queues/doesNotQualify', title: 'DNQ Queue' },
  { path: 'pages/queues/background', title: 'Case Management Queue' }
];

const match = queueMappings.find(item =>
  this._router.url.includes(item.path)
);

if (match) {
  this.pagename = match.title;
  return;
}



    const pageDetails = getCurrentPage?.route === `/${currentUrlPath}` ? getCurrentPage : undefined;
    if(pageDetails?.route === `/message-center`)
    {
      pageDetails.active = true ;
        const menus = this.localstorage.getObj('MENU');
        const findMenu = menus.find(item => item.name === 'Message Center');
        menus.forEach(item => {
          item.active = item === findMenu;
        });
          this.authService.getCurrentMenu(menus);
        
     
    }
    if (pageDetails) {
      this.pagename = getCurrentPage?.name || getCurrentPage;
    } else if (getCurrentPage?.submenu?.length) {
      this.handleSubmenuPages(getCurrentPage);
    } else {
      this.pagename = getCurrentPage?.name || getCurrentPage;
    }
  }

  private handleSubmenuPages(getCurrentPage) {
    const activeSubmenuPage = getCurrentPage.submenu.find(item => item?.active);
    const matchingSubmenuPage = getCurrentPage.submenu.find(item =>
      /**
       * Using `endsWith` instead of `includes` to avoid incorrect matches when one route
       * is a prefix of another (e.g., "/page-designer/migration-logs" matching "/page-designer")
       */
      // window.location.pathname.includes(item?.route || item?.id)
      window.location.pathname.endsWith(item?.route || item?.id)

    );

    this.pagename = activeSubmenuPage?.name || getCurrentPage?.name || getCurrentPage;
    if (matchingSubmenuPage?.name) {
      this.pagename = matchingSubmenuPage.name || getCurrentPage?.name || getCurrentPage;
    }
  }

  private setPagename() {
    if (typeof this.pagename === 'string') {
      this.localstorage.setItem('pagename', this.pagename);
      this.previouslySelectedMenu = this.pagename;
    }
  }

  private checkAndRestorePagename() {
    if (typeof this.pagename === 'object' || !this.pagename) {
      this.pagename = this.localstorage.getItem('pagename');
    }
  }

  checkInternetConnected() {
    this.connectionService.monitor().subscribe(newState => {
      this.currentState = newState;
      if (newState.hasNetworkConnection) {
        this.isOnline = true;
        if (this.sessionExpiredBoolean) {
          this.sessionExpiredPopUp = false;
          this.sessionExpiredBoolean = false;
          this.countdown = null;
          this.idle.setIdle(1);
          this.idle.watch();
        } else {
          $(noInternetWithTimmerSelector).modal('hide');
          $(noInternetSelector).modal('hide');
        }
      } else {
        this.isOnline = false;
        if (this.sessionExpiredPopUp) {
          this.sessionExpiredBoolean = true;
          $(sessionExpiredSelector).modal('hide');
          $(noInternetSelector).modal('hide');
          this.countdown = null;
          this.idle.setIdle(1);
          this.idle.watch();
          $(noInternetWithTimmerSelector).modal({ backdrop: 'static', keyboard: false }, 'show');
        } else {
          $(noInternetSelector).modal({ backdrop: 'static', keyboard: false }, 'show');
        }
      }
    });
  }

  private storageEventStart(): void {
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent) {
    if (event.storageArea == localStorage) {
      if (event?.key && event.key == logoutEvent) {
        this.onLoggedout();
      }
      if (event?.key && event.key == 'refresh-token') {
        this.refreshToken();
      }
    }
  }

  private storageEventStop(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
  }

  handleMenuToggle(isOpen: boolean) {
    this.isMenuOpen = isOpen;
  }
  openPopup() {
    this.isPopupVisible = true;
    this.searchQuery = ''; // Reset input when opening popup
    // Add the global click listener
    this.globalClickUnlistener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
      const clickedInsidePopup = this.popupRef?.nativeElement.contains(event.target);
      const clickedInsideTrigger = this.triggerRef?.nativeElement.contains(event.target);

      if (!clickedInsidePopup && !clickedInsideTrigger) {
        this.closePopup();
      }
    });
  }

  closePopup() {
    this.isPopupVisible = false;
    this.searchResult = { data: [] };
    this.groupedResults = {};
    this.searchQuery = '';
    // Remove the click listener
    if (this.globalClickUnlistener) {
      this.globalClickUnlistener();
      this.globalClickUnlistener = null;
    }
  }
  onSearchInput() {
    if (this.searchQuery.trim().length > 0) {
      // console.log('Searching for:', this.searchQuery);
      // Call search function with the search query
      if (this.searchQuery.trim().length > 3) {
        this.search(this.searchQuery);
      } else {
        this.searchResult = { data: [] };
        this.groupedResults = {};
      }

    } else {
      this.searchResult = { data: [] };
      this.groupedResults = {};
    }
  }

  trackByGroupKey(index: number, group: any): string {
    return group.key; // Use group key as a unique identifier
  }

  trackByItem(index: number, item: any): any {
    return item.id || index; // Use item ID or index as a fallback
  }

  trackByField(index: number, field: any): string {
    return field.label; // Use field label as a unique identifier
  }

  getVisibleItems(groupKey: string, items: any[]): any[] {
    return this.expandedIndexes[groupKey] ? items : items.slice(0, 3);
  }

  // Function to fetch search results
  isSearching: boolean = false;
  searchError: string = null;
  search(query: string) {
    this.isSearching = true;
    this.searchError = null;
    this.globalSearchService.searchData(query).subscribe(
      _data => {
        // console.log('Search Results:', _data);
        this.searchResult = _data;
        console.log(_data.data?.results, '_data.data?.results');

        this.searchResult.data = _data.data?.results?.map((hit: any) => ({
          index: hit.index,
          source: hit.source,
          redirectUrl: hit.redirectUrl  // Include redirectUrl for redirection
        })) || [];

        // Group by index
        this.groupedResults = this.searchResult.data.reduce((acc, item) => {
          acc[item.index] = acc[item.index] || [];
          acc[item.index].push(item);
          return acc;
        }, {});

        this.expandedIndexes = {};
        this.activeTab = 'all';  // Reset to "All" tab after search
        this.isSearching = false;
      },
      error => {
        // console.error('Search Error:', error);
        this.searchError = 'An error occurred while searching. Please try again.';
        this.searchResult = { data: [] };
        this.groupedResults = {};
        this.isSearching = false;
      }
    );
  }

  // Function to switch tabs
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  // Function to get total count of all records
  getTotalCount(): number {
    return (Object.values(this.groupedResults) as any[]).reduce((sum, group) => sum + group.length, 0);
  }


  // Function to toggle expand/collapse
  toggleExpand(index: string) {
    this.expandedIndexes[index] = !this.expandedIndexes[index];
  }

  // Function to get fields from source
  getFields(source: any): any[] {
    return Object.keys(source).map(key => {
      let value = source[key];

      if (Array.isArray(value)) {
        return {
          label: key.replace(/_/g, ' '),
          value: value.map(item => ({
            isObject: typeof item === 'object' && item !== null,
            value: item
          })),
          isArray: true,
          isObject: false
        };
      }

      return {
        label: key.replace(/_/g, ' '),
        value: value,
        isArray: false,
        isObject: typeof value === 'object' && value !== null
      };
    });
  }

  getItemUrl(item: any): string {
    // Return the redirectUrl if available, else fallback to default URL
    return item.redirectUrl;
  }

  isFieldValueValid(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string' && value.trim() === '') {
      return false;
    }
    if (Array.isArray(value) && value.length === 0) {
      return false;
    }
    if (typeof value === 'object' && Object.keys(value).length === 0) {
      return false;
    }
    return true;
  }

  settingDataSourceInElasticSearch(): void {
    this.elasticDataStore.setData('RBACORG', { environment });
    this.elasticDataStore.setData('HTTPSERVICE', this.httpService);
  }



  isCapsLockOnCurrent: boolean = false;
  isCapsLockOnNew: boolean = false;
  isCapsLockOnConfirm: boolean = false;
  namesObj: any[]=[];
  email: string = sessionStorage.getItem('email');
  placeholderMessages: any[] = [];
  placeholderMessage: any = {};

  // Dynamic password validation rules
  get passwordValidationRules() {
    return [
      {
        key: 'minLength',
        message: this.errorMessage['M0027'],
        isValid: () => this.passwordHasMinLength()
      },
      {
        key: 'hasCapitalCase',
        message: this.errorMessage['M0028'],
        isValid: () => !this.resetFormcontrols['newpassword'].hasError('hasCapitalCase') && this.resetFormcontrols['newpassword'].value
      },
      {
        key: 'hasSmallCase',
        message: this.errorMessage['M0029'],
        isValid: () => !this.resetFormcontrols['newpassword'].hasError('hasSmallCase') && this.resetFormcontrols['newpassword'].value
      },
      {
        key: 'hasNumber',
        message: this.errorMessage['M0030'],
        isValid: () => !this.resetFormcontrols['newpassword'].hasError('hasNumber') && this.resetFormcontrols['newpassword'].value
      },
      {
        key: 'hasSpecialCharacters',
        message: this.errorMessage['M0031'],
        isValid: () => !this.resetFormcontrols['newpassword'].hasError('hasSpecialCharacters') && this.resetFormcontrols['newpassword'].value
      },
      {
        key: 'noName',
        message: this.errorMessage['M0032'],
        isValid: () => this.checkNoPersonalInfo(this.resetFormcontrols['newpassword'].value)
      },
      {
        key: 'noSpaces',
        message: this.errorMessage['M0033'],
        isValid: () => !this.passwordContainsSpaces() && this.resetFormcontrols['newpassword'].value
      }
    ];
  }

  @HostListener('document:keydown', ['$event'])
  @HostListener('document:keyup', ['$event'])
  @HostListener('document:focusin', ['$event'])
  @HostListener('document:mouseup', ['$event'])
  handleCapsLockDetection(event: KeyboardEvent | FocusEvent | MouseEvent): void {

    const target = event.target as HTMLElement;
    if (target.tagName !== 'INPUT') return;
    const inputId = target.getAttribute('id');
    if (!inputId) return;

    const isOn = (event.type !== 'mousedown')  ? (event as KeyboardEvent).getModifierState?.('CapsLock') || false
                                          : (event as MouseEvent).getModifierState?.('CapsLock') || false;
    
    if (inputId === 'input_pages_currentPassword') {
      this.isCapsLockOnCurrent = isOn;
    } else if (inputId === 'input_pages_newPassword') {
      this.newPassword.valueChanges.subscribe(() => {
        this.newPassword.valid ? this.confirmPassword.enable() : this.confirmPassword.disable();
      })
      this.isCapsLockOnNew = isOn;
    } else if (inputId === 'input_pages_confirmPassword') {
      this.isCapsLockOnConfirm = isOn;
    }
  }

  @HostListener('document:focusout', ['$event'])
  handleCapsLockBlur(event: FocusEvent): void {
    const target = event.target as HTMLElement;
    
    if (target.tagName !== 'INPUT') return;
    
    const inputId = target.getAttribute('id');
    if (!inputId) return;
    
    if (inputId === 'input_pages_currentPassword') {
      this.isCapsLockOnCurrent = false;
    } else if (inputId === 'input_pages_newPassword') {
      this.isCapsLockOnNew = false;
    } else if (inputId === 'input_pages_confirmPassword') {
      this.isCapsLockOnConfirm = false;
    }
  }

  
  checkNoPersonalInfo(password: string): boolean {
    // Convert password to lowercase for case-insensitive comparison
    const passwordLower = password.toLowerCase();
    
    // Check if password contains any name from namesObj
    if (!this.namesObj || this.namesObj.length === 0) {
      // If no personal data is available, pass this validation
      return true;
    }
    
    for (const nameObj of this.namesObj) {
      // Check for first name
      if (nameObj.first_name && nameObj.first_name.trim() !== '' && 
          nameObj.first_name.length > 2 && 
          passwordLower.includes(nameObj.first_name.toLowerCase())) {
        return false;
      }
      
      // Check for middle name
      if (nameObj.middle_name && nameObj.middle_name.trim() !== '' && 
          nameObj.middle_name.length > 2 && 
          passwordLower.includes(nameObj.middle_name.toLowerCase())) {
        return false;
      }
      
      // Check for last name
      if (nameObj.last_name && nameObj.last_name.trim() !== '' && 
          nameObj.last_name.length > 2 && 
          passwordLower.includes(nameObj.last_name.toLowerCase())) {
        return false;
      }
    }
    
    // If no personal information found in password
    return true;
  }

  private fetchInactivityTimeoutFromLookup(): Promise<number> {
    return new Promise((resolve) => {
      this.registrationService.getBusinessRuleByKey('Security', 'inactivity_timeout')
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            const timeout = res?.data?.data?.intValue ? Number(res.data.data.intValue) : 15;
            resolve(timeout);
          },
          error: () => resolve(15)
        });
    });
  }


  get isCurrentPasswordInvalid(): boolean {
    const control = this.resetPasswordForm.get('currentpassword');
    return control.touched && control.hasError('required');
  }

  get isNewPasswordInvalid(): boolean {
    const control = this.resetPasswordForm.get('newpassword');
    return control.touched && control.hasError('required') && !control.value;
  }

  get isConfirmPasswordInvalid(): boolean {
    const control = this.resetPasswordForm.get('conformpassword');
    return control.touched && control.hasError('required') && !control.value; 
  }

  get newPassword() {
    return this.resetPasswordForm.get('newpassword'); 
  } 

  get confirmPassword() {
    return this.resetPasswordForm.get('conformpassword'); 
  }
  
  get currentPassword() {
    return this.resetPasswordForm.get('currentpassword');
  }

getNotificationCount(): void {

 this.notificationCountSub?.unsubscribe();

 this.notificationCountSub = this._mailNotificationService
   .getApplicationNotificationCount()
   .pipe(
     filter(res => !!res),
     map(res => res['data'] || 0)
   )
   .subscribe({
     next: (count: number) => {
       this.notificationCount = count;
       this.updatePlatformHeaderConfig();
     },
     error: err => console.error('Failed to fetch notification count', err)
   });
}

@HostListener('document:visibilitychange')
onVisibilityChange(): void {

 this.applicationHidden = document.hidden;

 if (!this.applicationHidden) {
   this.flashInterval$?.unsubscribe();
   this.flashInterval$ = null;
   this.document.title = this.currentTitle;
 }
}

flashNotificationTitle(): void {

 let toggle = false;

 this.flashInterval$ = interval(1000).subscribe(() => {

   this.document.title = toggle
     ? this.currentTitle
     : '🔔 New Notification';

   toggle = !toggle;
 });
}

  private updatePlatformHeaderConfig(): void {
    this.headerConfig = this.headerConfigService.updateDynamicValues(
      this.headerConfig,
      {
        title: this.headerConfigService.resolveTitle(this.pagename, this.previouslySelectedMenu),
        notificationCount: this.notificationCount,
        userName: this.showname,
        thumbnailUrl: this.thumbnail
      }
    );
  }
  private isOnFeePaymentPage(): boolean {
    const fullUrl = window.location.href;
    return fullUrl.includes('fee-payment');
  }

   private buildHeaderContext(): void {
    this.headerContext = this.headerConfigService.buildContext({
      rbacOrg: {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.localstorage?.asStorage?.() ?? window.localStorage,
        orgID: this.localstorage?.getItem?.('orgid'),
        environment
      },
      permission: this.permissionStore?.state,
      httpService: this.httpService,
      authService: this.authService,
      appService: this.appService,
      pagesService: this.pagesservice,
      dataStoreService: this.storeService,
      globalSearchService: this.globalSearchService,
      alertService: this.alertService,
      router: this._router
    });
  }
  ngAfterViewInit() {
  setTimeout(() => {
    const closeBtn = document.querySelector('.p-sidebar-close');

    if (closeBtn) {
      closeBtn.setAttribute('aria-label', 'Close sidebar');
    }
  });
}

@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const link = target.closest('.fbw-content a') as HTMLAnchorElement;

  if (link) {
    event.preventDefault();
    window.open(link.href, '_blank', 'noopener,noreferrer');
  }
}

}